import { Box, Typography, Dialog, DialogContent } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { path } from 'config/path';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import { Button } from "@mui/material";

const POPUPNOTE1 = "Premium Korean Head Spa Exclusively at Jubilee Soho ✨"
const POPUPNOTE2 = "Powered by HISTEMO, Korea’s leading scalp science brand, our luxurious Head Spa ritual deeply cleanses, nourishes, and revitalises the scalp. Experience healthier roots, stronger hair, and a natural shine that lasts."

const PromoPopup = ({popup=null}) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false); // You can control this state based on your logic

  useEffect(() => {
    if (popup) setOpen(true);
  },[popup]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleClick =() => {
    //console.log('click');
    //setOpen(false);
    //navigate(popup.note)
  }
  if (!popup) return <></>

  return (
    <Dialog
        open={open}
        onClose={handleClose}
        //maxWidth="sm"
        //fullWidth
        PaperProps={{
          sx: {
            position: "relative",
            overflow: "hidden", 
            width : "calc(100%-32px)",
          },
        }}
      >
        <DialogContent sx={{ padding: '1em', position: "relative", textAlign: "center", backgroundColor: '#fff8f0' }}>
          {/* Close Button */}
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              padding : 0,
              top: 5,
              right: 5,
              color: "darkgrey", 
              zIndex: 1, 
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* Promotion Image */}
          {/* <Box
            component="img"
            src={`${path.ciHost}/uploads/${popup.store_id}/` + popup.filename} //{`${path.basename}/images/choice/popup_promo.jpg`}
            alt="Promotion"
            sx={{ width: "100%", height: "auto" }}
            onClick={handleClick}
          /> */}
          <Typography variant="h4" sx={{
            fontWeight: 800,
            fontSize: '2em',
            pt: '1em',
            pb: '0.5em',
            lineHeight: '1.5em',
            color: '#5a3e36'
          }}>
            {POPUPNOTE1} 
            {/*{popup ? popup.note.split('\n\n')[0] : ''} */}
          </Typography>
          <Typography variant='h5' sx={{ lineHeight: '1.5em', py: '1em', whiteSpace: 'pre-line', color:'#333333' }}>
            {POPUPNOTE2} 
            {/* {popup ? popup.note.split('\n\n')[1] : ''}  */}
            <br/><br/>✂️✨🫶<br/><br/><br/>            
          </Typography>
          <Button 
            href={`${path.basename}/hairspa`}  
            variant='contained' 
            sx={{ 
              mb:'1em', 
              backgroundColor:'#ff6b6b', 
              color:'white',
              position: "absolute",
              padding : 0,
              bottom: 2,
              left: '50%',
              transform: 'translateX(-50%)',
              zIndex: 1, 
              width: '50%',
              borderRadius: '10px',
              '&:hover': {
                backgroundColor: '#ff6b6b'
              },
              '&:active': {
                backgroundColor: '#ff6b6b'
              },
              '&:focus': {
                backgroundColor: '#ff6b6b'
              }
            }} 
          >
            <Typography sx={{ fontWeight:'800', p:'1em'}}>
              Learn More
            </Typography>
          </Button>
        </DialogContent>
      </Dialog>
  )
};

export default PromoPopup;